import React from "react";
import { Link } from "react-router-dom";

const variants = {
  primary:
    "bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-[0_10px_30px_-10px_hsl(var(--primary)/0.6)]",
  secondary:
    "bg-secondary text-secondary-foreground hover:bg-secondary/90",
  outline:
    "border border-border bg-transparent text-foreground hover:border-primary hover:text-primary",
  ghost: "bg-transparent text-foreground hover:text-primary",
};

const sizes = {
  sm: "h-9 px-4 text-xs",
  md: "h-11 px-6 text-sm",
  lg: "h-14 px-8 text-base",
};

const Button = React.forwardRef(
  (
    {
      variant = "primary",
      size = "md",
      to,
      href,
      children,
      className = "",
      icon: Icon,
      iconRight: IconRight,
      ...props
    },
    ref
  ) => {
    const cls = `inline-flex items-center justify-center gap-2 rounded-sm font-medium uppercase tracking-[0.16em] transition-all duration-300 active:scale-[0.97] focus:outline-none focus:ring-2 focus:ring-primary/40 ${variants[variant]} ${sizes[size]} ${className}`;

    const content = (
      <>
        {Icon && <Icon size={16} weight="bold" />}
        <span>{children}</span>
        {IconRight && <IconRight size={16} weight="bold" />}
      </>
    );

    if (to) {
      return (
        <Link to={to} className={cls} ref={ref} {...props}>
          {content}
        </Link>
      );
    }
    if (href) {
      return (
        <a href={href} className={cls} ref={ref} {...props}>
          {content}
        </a>
      );
    }
    return (
      <button className={cls} ref={ref} {...props}>
        {content}
      </button>
    );
  }
);
Button.displayName = "Button";

export default Button;
